import { render, staticRenderFns } from "./ReviewJobDetails.vue?vue&type=template&id=4a39d4a7&scoped=true&"
import script from "./ReviewJobDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewJobDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewJobDetails.vue?vue&type=style&index=0&id=4a39d4a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39d4a7",
  null
  
)

export default component.exports